import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-mist" data-id="element-110" data-mp="2lu4o5ip4lm78">
      <div className="mx-auto max-w-3xl px-4 py-5 sm:py-8" data-id="element-111" data-mp="30hhb9bukzzzq">
        <SectionHeader id="problema" eyebrow="¿Te suena familiar?" title="Das clases de electricidad, pero cada semana vuelves a invertir horas preparando materiales." description="Si eres profesor, instructor o maestro de taller, probablemente conozcas alguna de estas situaciones:" data-id="element-112" data-mp="30j0w7fr6mz7u" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-113" data-mp="3jgbsqslfjejl">
          {problems.map(p => {
          const Icon = p.icon;
          return <li key={p.title} className="flex gap-2.5 rounded-lg border-l-4 border-spark bg-white p-3 shadow-sm" data-id="element-114" data-mp="3ehs7kuenu6sa">
                <Icon size={18} aria-hidden="true" className="mt-0.5 flex-shrink-0 text-electric" data-id="element-115" data-mp="1p3vnnv4de6gb" />
                <div data-id="element-116" data-mp="1k5al3p1nbaop">
                  <h3 className="font-display text-sm font-extrabold text-navy" data-id="element-117" data-mp="jdn5i4pl305g">{p.title}</h3>
                  <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-118" data-mp="obye6c4574m3">{p.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}